var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-4 mt-2"
  }, [_vm.isBackButtonVisible ? _c('i', {
    staticClass: "fa-solid fa-arrow-left mb-4",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _c('h5', {
    staticClass: "text-center flex-grow-1"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.modalHeading) + " ")])])]), !_vm.showPreview ? _c('section', {
    staticClass: "table-section"
  }, [_c('section', [_c('p', [_vm._v("Please select at least one category to continue")]), _c('multiselect', {
    staticClass: "custom-multiselect",
    attrs: {
      "options": _vm.categoryList,
      "value": _vm.selectedCategories,
      "track-by": "value",
      "placeholder": "Select one or more categories",
      "label": "text",
      "multiple": true,
      "searchable": true
    },
    on: {
      "select": _vm.onCategorySelect,
      "remove": _vm.onCategoryRemove
    }
  })], 1), this.selectedCategories.length > 0 ? _c('section', [_vm._m(0), _c('p', {
    staticClass: "heading"
  }, [_vm._v("Select Plans")]), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', [_c('tbody', _vm._l(_vm.planList, function (planDetail) {
    return _c('tr', {
      key: planDetail.category
    }, [_c('td', {
      staticClass: "category-cell"
    }, [_vm._v(_vm._s(planDetail.category))]), _c('td', [_c('div', {
      staticClass: "plan-list"
    }, _vm._l(planDetail.plans, function (plan) {
      return _c('plan-checkbox', {
        key: plan.value,
        attrs: {
          "checkbox-item": plan,
          "checked": _vm.isChecked(plan)
        },
        on: {
          "onChange": _vm.onCheckboxClicked
        }
      });
    }), 1)])]);
  }), 0)])]), _c('div', {
    staticClass: "preview-btn-wrapper"
  }, [_vm.cart !== null && _vm.cart.length > 0 ? _c('button', {
    staticClass: "new-quote-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.togglePreviewModal
    }
  }, [_vm._v("Preview")]) : _vm._e()])]) : _vm._e()]) : _c('section', [_c('h6', {
    staticClass: "fw-bold mb-2"
  }, [_vm._v("Reveiw plans and pricing")]), _c('div', {
    staticClass: "col-xxl-12 col-xl-12 col-lg-12 col-md-12"
  }, [_c('div', {
    staticClass: "cart-list"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-x": "unset !important"
    }
  }, [_vm.cart !== null && _vm.cart.length > 0 ? _c('table', {
    staticClass: "table",
    staticStyle: {
      "border-collapse": "unset"
    }
  }, [_vm._m(1), _c('tbody', {
    staticStyle: {
      "max-height": "150px !important",
      "overflow-y": "scroll"
    }
  }, _vm._l(_vm.cart, function (plan, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "d-flex align-items-center gap-4"
    }, [_c('div', {
      staticClass: "vendor-img"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": "".concat(plan.plan_logo)
      }
    })]), _c('div', [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v(" " + _vm._s(plan.plan_name) + " ")])])])]), _c('td', [_c('div', {
      staticClass: "price"
    }, [_vm._v("$" + _vm._s(plan.price))])])]);
  }), 0)]) : _c('section', {
    staticClass: "d-flex justify-content-center align-items-center",
    attrs: {
      "id": "selected-plans-list"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("No plans selected yet")])])])])]), _vm.cart && _vm.fees ? _c('div', [_c('p', {
    staticClass: "mt-4 mb-2 fw-bold"
  }, [_vm._v("Processing Charges")]), _c('div', {
    staticClass: "procesing-fee"
  }, [_c('p', [_vm._v("One Time Processing Fee: "), _c('span', [_vm._v(_vm._s("$ ".concat(_vm.fees.oneTimeProcessingFee)))])]), _c('p', [_vm._v("First Month Cost: "), _c('span', [_vm._v(_vm._s("$ ".concat(_vm.fees.firstMonthFee)))])]), _c('p', [_vm._v("Recurring Month Cost: "), _c('span', [_vm._v(_vm._s("$ ".concat(_vm.fees.recurringFee)))])]), _c('hr', {
    staticClass: "separator"
  }), _c('p', [_vm._v("Total Cost: "), _c('span', [_vm._v(_vm._s("$ ".concat(_vm.fees.totalFee)))])])])]) : _vm._e(), _c('div', {
    staticClass: "col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end gap-2"
  }, [_c('button', {
    staticClass: "new-quote-btn close-preview-btn mt-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.togglePreviewModal
    }
  }, [_vm._v("Cancel")]), _c('button', {
    staticClass: "new-quote-btn confirm-quote-btn mt-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitQuote
    }
  }, [_vm._v("Confirm")])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "disclaimer"
  }, [_c('p', [_vm._v("Note:")]), _c('p', [_vm._v("You can select one or multiple plans. On selecting a plan it will be added to cart which can be viewed using the preview button. Selecting plan from same category overrides the previous plan from that category. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _c('th', [_vm._v("Total Price")])])]);
}]

export { render, staticRenderFns }